export default {
  name: (state) => state.translations[state.selectedLocale]?.name,
  description: (state) => state.translations[state.selectedLocale]?.description,
  locale: (state) => state.selectedLocale,
  isShown: (state) => state.isShown,
  selectedServices: (state) => state.selectedServices,
  services: (state) => state.services,
  selectedServiceTypes: (state) => state.selectedServiceTypes,
  serviceTypes: (state) => state.serviceTypes,
  places: (state) => state.places,
  place: (state) => state.place,
  homePagePositionsKeys: (state) => state.homePagePositions.map((item) => item.key),
  positions: (state, getters) => (getters.place === 'home_page'
    ? getters.homePagePositionsKeys
    : state.positions.filter((position) => !getters.homePagePositionsKeys.includes(position))
  ),
  position: (state) => state.position,
  networks: (state) => state.networks,
  network: (state) => state.network,
  serviceType: (state) => state.serviceType,
  id: (state) => state.id,
  isArchive: (state) => state.isArchive,
  translations: (state) => state.translations,
  isEnabled: (state) => state.isEnabled,
  canMoreLoadServices: (state) => state.canMoreLoadServices,
  errors: (state) => state.errors,
};
